import { render, staticRenderFns } from "./CreateGroupSurveyDetails.vue?vue&type=template&id=1d265c67&scoped=true"
import script from "./CreateGroupSurveyDetails.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyDetails.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupSurveyDetails.vue?vue&type=style&index=0&id=1d265c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d265c67",
  null
  
)

export default component.exports